import { useInstance, onBeforeUnmount } from 'intact-vue';
export function useAutoplay(next) {
  var instance = useInstance();
  var timer = null;
  var ms;
  instance.on('$receive:autoplay', function (v) {
    if (v === true) {
      ms = 5000;
    } else {
      ms = v || 0;
    }
    stop();
    play();
  });
  function play() {
    if (ms) {
      timer = window.setTimeout(function () {
        next();
        play();
      }, ms);
    }
  }
  function stop() {
    if (timer) {
      window.clearTimeout(timer);
      timer = null;
    }
  }
  onBeforeUnmount(stop);
  return {
    stop: stop,
    play: play
  };
}